import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { EditAccountForm, FormErrors } from "PFModules/saas_admin/accounts/edit/edit_account.types";

import { updateAccount } from "../../../services/accounts/account";
import { accountsKeys } from "./query_keys";

type UseAccountUpdate = {
  onSuccess: () => void;
  onError: (error: any) => void;
};

export const useAccountUpdate = ({ onSuccess, onError }: UseAccountUpdate) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ accountId, accountData }: { accountId: number; accountData: EditAccountForm }) =>
      updateAccount(accountId, accountData),
    onSuccess: (_, { accountId }) => {
      queryClient.invalidateQueries(accountsKeys.account(accountId));
      onSuccess();
    },
    onError: (error: AxiosError<{ errors: FormErrors }>) => {
      onError(error.response?.data.errors);
    }
  });
};
